module.exports = __webpack_public_path__ + "static/media/template6.bed38856.webp";